export const DOCUMENTO_CONCILIABLE = {
  FACTURA: 1,
  DEVOLUCION: 2,
  AMORTIZACION: 3,
  FLUJO_TESORERIA: 4,
  LINEAS_ASIENTO_CONTABLE: 5,
} as const

export type DocumentoConciliableType =
  (typeof DOCUMENTO_CONCILIABLE)[keyof typeof DOCUMENTO_CONCILIABLE]
